/**
 * List of frontend apps, used for various purposes.
 * As of this writing, only used for Google Analytics.
 */
export enum AppList {
  Candidate = 'candidate',
  Agent = 'agent',
}
